"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    mainImage: {
      width: '400px',
      height: 'auto',
      border: '1px solid #dad5cf'
    },
    smallImage: {
      width: '78px',
      height: 'auto',
      border: '1px solid #dad5cf',
      cursor: 'pointer'
    },
    selectedBorder: {
      border: '2px solid #33447c'
    }
  };
});

var ProductImagePreview = function ProductImagePreview(_ref) {
  var images = _ref.images;
  var classes = useStyles();

  var _useState = (0, _react.useState)(images[0]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      mainImage = _useState2[0],
      setMainImage = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "product",
    className: classes.mainImage,
    src: mainImage
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    pl: 3
  }, images.map(function (image) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      onClick: function onClick() {
        return setMainImage(image);
      },
      pb: 1,
      key: image
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "preview",
      className: (0, _classnames.default)(classes.smallImage, image === mainImage ? classes.selectedBorder : ''),
      src: image
    }));
  })));
};

ProductImagePreview.propTypes = {
  images: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
var _default = ProductImagePreview;
exports.default = _default;